// @ts-ignore
import UAParser from '@amplitude/ua-parser-js';
import { UAParserInstance } from 'ua-parser-js';

import { getNativeAppVersion } from './getNativeAppVersion';
import { isApp } from './isApp';
import { isMobile } from './isMobile';
import { isWhaleBrowser } from './isWhaleBrowser';

const parser = new UAParser() as UAParserInstance;

export const getDeviceInformation = () => {
  const device = parser.getDevice();
  const browser = parser.getBrowser();
  const os = parser.getOS();

  return {
    device,
    browser,
    os,
    isMobile: isMobile(),
    isWhaleBrowser: isWhaleBrowser(),
    isApp: isApp(),
    appVersion: getNativeAppVersion(),
  };
};
